import src from "IMAGE";
export default { src, width: 288, height: 69, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADc3OFgkJCU6LCwsSCwsLV0aGhtTFhYXRxkZGkwUFBQ5ACkpKkYkJCQ4JycoQCAgIUUVFRZEGxscTx8fIFccHB1IcY0KxrJK4qcAAAAASUVORK5CYII="};
